import React from "react"
import Highcharts from 'highcharts'
import { Spinner } from 'reactstrap'
import HighchartsReact from 'highcharts-react-official'
import ApiService from '../services/ApiService'
import { connect } from "react-redux"
import { format } from "date-fns";
import { useQuery } from "@tanstack/react-query";

const PressCountBarChart = ({ date, tenant, params }) => {
  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  const { data, isLoading, isRefreshing, isSuccess } = useQuery({
    queryKey: ["brandPressCount", tenant.id, startDate, endDate, params],
    queryFn: () => ApiService.getBrandPressCount(since, until, params),
    select: (data) => data.data,
    enabled,
    placeholderData: { data: [] },
  });

  const chartOptions = (graph) => {
    return {
      credits: { enabled: false },
      chart: {
        type: "bar",
        height: "700px",
        backgroundColor: 'transparent',  // <-- Add background color
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: data.yTitle,
        },
        labels: {
          style: {
            color: 'var(--text-primary)'
         }
        }
      },
      xAxis: {
        categories: data.labels,
        labels: {
          rotation: -45,
          style: {
            color: 'var(--text-primary)'
         }
        },
        title: {
          text: data.xTitle,
        },

      },
      series: data.series,
      plotOptions: {
        column: {
          stacking: "normal",
        },
        series: {
          borderColor: null,
        },
      },
    };
  };

  return (
    <>
      {isLoading && isRefreshing && <Spinner color="primary" />}
      {isSuccess && (
        <HighchartsReact highcharts={Highcharts} options={chartOptions()} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  date: state.date,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(PressCountBarChart);
